import React, { useRef, forwardRef } from 'react';

import noveltyText from "/assets/images/2022aug/menu_novelty.png";

import AnchorLink from 'react-anchor-link-smooth-scroll';

import '../styles/Menu.scss' 

const Menu = forwardRef((props, ref) => {

    // const menu = useRef();
    // useEffect(() => {
    //     console.log(menu.current);
    //     gsap.set(menu.current, 
    //       {autoAlpha: 0,
    //       x: 300
    //       }
    //       );
    // });

    // const linkData = [
    //     {
    //         href: "#bellini",
    //         text: `PINK\nBELLINI`
            
    //     },
    //     {
    //         href: "#milky",
    //         text: `MILKY &amp;\nCARAMEL COCO`
    //     },
    //     {
    //         href: "#novelty",
    //         text: "NOVELTY"
    //     },
    // ]

    return (
        <div className="menu" id="menu" ref={ref}>
            <ul className="menu__list">
                <li className="menu__item"><AnchorLink href="#bellini">PINK<br></br>BELLINI</AnchorLink></li>
                <li className="menu__item"><AnchorLink href="#milky">MILKY &amp;<br></br>CARAMEL COCO</AnchorLink></li>
                <li className="menu__item image"><AnchorLink href="#novelty"><span><img src={noveltyText} alt="" /></span></AnchorLink></li>
                {/* <li className="menu__item"><AnchorLink href="#novelty">NOVELTY</AnchorLink></li> */}
                {/* {linkData.map((data) => {
                    return (
                        <li className="menu__item"><AnchorLink href={data.href}>{data.text}</AnchorLink></li>
                    )
                })} */}
            </ul>
        </div>
    )
})

export default Menu